import { formatMoney, SinglePaymentCriteria } from '@nemuru-eng/js-api-client';

import { SinglePaymentStatusLabel } from '@/components/modules/SinglePaymentListByProduct/components/SinglePaymentStatusLabel';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

export const statusWithPrincipalAmountMobile = ({ flex }: { flex?: number }) => {
  const { palette } = useCustomTheme();
  return {
    flex: flex ?? 0.5,
    field: 'status',
    headerName: <Text tId={'STATUS'} />,
    renderCell: (rowData: { row: SinglePaymentCriteria }) => {
      return (
        <div style={{ minWidth: '120px' }}>
          <div style={{ minWidth: '120px' }}>
            <SinglePaymentStatusLabel status={rowData.row.status} />
          </div>
          <div style={{ color: palette.text.secondary }}>
            <strong>{formatMoney(amountToValueMoneyMapper(rowData.row.principal))}</strong>
          </div>
        </div>
      );
    },
  };
};
